import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {
  RequestChangePassDto,
  RequestCheckPassDto,
  ResponseChangePassDto,
  ResponseCheckPassDto,
} from "../dto/sfpayslip.dto";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SfpayslipApi {

  private service: string = '';
  private model: string = 'sfpayslip';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public checkPass(payload: RequestCheckPassDto): Observable<ResponseCheckPassDto> {
    const method: string = 'GET';
    const func: string = 'checkPass';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCheckPassDto>(method, url, params, urlParams, body);
  }

  public changePass(payload: RequestChangePassDto): Observable<ResponseChangePassDto> {
    const method: string = 'GET';
    const func: string = 'changePass';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseChangePassDto>(method, url, params, urlParams, body);
  }

  public changePassNew(payload: RequestChangePassDto): Observable<ResponseChangePassDto> {
    const method: string = 'POST';
    const func: string = 'changePassNew';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseChangePassDto>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-payslip.api.ts